import type { FaireProductEntity } from "../../entity_types/product";

export const p_zu3x362qw8: FaireProductEntity = {
  token: "p_zu3x362qw8",
  type: "product",
  name: "Christmas Print Loose Fit Sweatshirt Top",
  brandToken: "b_5apqh2a958",
  brandName: "Haptics",
  imageUrl:
    "https://cdn.faire.com/fastly/c898bd89afd852fbeeae7c9f871c7e55a7c3e19635aef64ae08378b743dc0d61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eae781851fefdb07dd100d45abb156f8b02095abf10afc29ff5c30d79bba1c50.jpeg",
    "https://cdn.faire.com/fastly/c2a01cec84351faa9795f8c3bb2260aba2822e94b8267f46eb2601ecf2050d6f.jpeg",
    "https://cdn.faire.com/fastly/bdcfc10f076e8aabd5c0bf13898162a3fdc85f96a1d71ea0dc2cfb79d6fb50cf.jpeg",
    "https://cdn.faire.com/fastly/985c7dc53e6434b4f50496e292fb1690e072a9193bc6524c20191faddbb158c6.jpeg",
    "https://cdn.faire.com/fastly/726b228c7b94ba69078e15e87ef00251a43ea70173c52821e253f159ece3a02c.jpeg",
    "https://cdn.faire.com/fastly/b8590c1f7823b9080522163a1722d24ca7c028eb6d21c25cb181a1b8888ac5d7.jpeg",
    "https://cdn.faire.com/fastly/c46e6e32c9934cac2631f50368a4f5f97bf0571dcde596e7adbb465be0d46b7e.jpeg",
  ],
  priceDollars: 125.7,
  description:
    "ROUND NECK DROP SHOULDER LONG SLEEVE OVERSIZED LOOSE FIT CHRISTMAS CANDY CANE, NUT CRACKER PRINT COTTON BLENDED FRENCH TERRY KNIT TOP WITH RIBBED BAND, CUFFS AND HEMLINE CUT EDGE, TRI ANGLE DETAI",
  tags: [],
  msrpDollars: 251.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:30.211Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
